// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-nav{align-items:center;display:flex;font-size:16px}.left-nav .ui-menu__anchor{color:var(--color-white)}.left-nav .left-nav-align{display:flex;flex-flow:row nowrap}.left-nav .left-nav-link{cursor:pointer;border-bottom:1px solid rgba(0,0,0,0);padding:10px 0 10px 0;white-space:nowrap;font-family:var(--font-regular);font-size:16px}.left-nav .left-nav-link--active{border-bottom:1px solid var(--color-white)}", ""]);
// Exports
module.exports = exports;
